// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "flightsSortings__wrapper-3tgWu";
export { _1 as "__esModule", _2 as "flightsSortings__wrapper" }
export default { "__esModule": _1, "flightsSortings__wrapper": _2 }
